import React, { Component } from 'react';
import { DISPATCH_ID } from "../../libs/utils/Const";
import { connect } from "react-redux";
import { ApiClient } from "../../libs/apiClient";
import $ from 'jquery';
import StandardSelectModal from '../StandardSelectModal';
let apiClient = ApiClient.getInstance();

const FORMAT_NUMBER = (num = "0", decimals = 2, sufix = "", prefix = "") => {
    const separador = ",", sepDecimal = "."; // separadores
    num = Number(num || 0).toFixed(decimals);
    let splitStr = num.split(".");
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
    let regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, "$1" + separador + "$2");
    }
      return prefix + splitLeft + splitRight + sufix;
};

class GroupNumbersModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: false,
            groupNum: null,
            model: {
                PaymentTermsGroupName: "", // PymntGroup
                StartFrom: "N", // PayDuMonth
                NumberOfAdditionalMonths: "0", // ExtraMonth
                NumberOfAdditionalDays: "0", // ExtraDays
                CreditLimit: "0.00", // CredLimit
                GeneralDiscount: "0.0000", // VolumDscnt
                InterestOnArrears: "0.0000", // LatePyChrg
                PriceListNo: "-1", // ListNum
                LoadLimit: "0.00", // ObligLimit
                OpenReceipt: "N", // OpenRcpt
                BaselineDate: "T", // BslineDate
                NumberOfToleranceDays: null, // TolDays
            },
            auxModel: null,
            showSelectModal: false,
            groupNumList: [],
            priceList: [],
        };
    }

    componentDidMount() {
        this.getInfo();
    }

    getInfo = async () => {
        const { GroupNum, enableSpinner } = this.props;
        let priceList = [];

        if (GroupNum !== null) { await this.searchGroupNum({ GroupNum }); }

        enableSpinner(true);
        priceList = await apiClient.getPriceList();
        priceList = Array.isArray(priceList?.data) ? priceList.data : [];
        enableSpinner(false);
        await this.setState({ priceList })
    }

    searchGroupNum = async (data) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let apiResponse = await apiClient.getGroupNumDetails(data);
        enableSpinner(false);

        if (!apiResponse?.status) {
            return showAlert({ type: 'error', message: apiResponse?.message || 'Ocurrió un error al consultar la Información' });
        }
        apiResponse = apiResponse.data;

        const groupNum = apiResponse.GroupNum;
        const model = {
            PaymentTermsGroupName: apiResponse.PymntGroup ||  "", // PymntGroup
            StartFrom: apiResponse.PayDuMonth ||  "N", // PayDuMonth
            NumberOfAdditionalMonths: apiResponse.ExtraMonth ||  "0", // ExtraMonth
            NumberOfAdditionalDays: apiResponse.ExtraDays ||  "0", // ExtraDays
            CreditLimit: FORMAT_NUMBER(apiResponse.CredLimit ||  "0", 2), // CredLimit
            GeneralDiscount: FORMAT_NUMBER(apiResponse.VolumDscnt ||  "0", 4), // VolumDscnt
            InterestOnArrears: FORMAT_NUMBER(apiResponse.LatePyChrg ||  "0", 4), // LatePyChrg
            PriceListNo: apiResponse.ListNum ||  "-1", // ListNum
            LoadLimit: FORMAT_NUMBER(apiResponse.ObligLimit ||  "0", 2), // ObligLimit
            OpenReceipt: apiResponse.OpenRcpt ||  "N", // OpenRcpt
            BaselineDate: apiResponse.BslineDate ||  "T", // BslineDate
            NumberOfToleranceDays: apiResponse.TolDays ||  null, // TolDays
        };

        this.setState({ groupNum, model });
        $("#selectGroupNumModal").modal("hide");
    }

    closeModal = async () => {
        $('#GroupNumbersModal').modal('hide');
    }

    openSelectModal = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let { groupNumList } = this.state;

        enableSpinner(true);
        if (!groupNumList.length) {
            groupNumList = await apiClient.getGroupNum();

            if (!Array.isArray(groupNumList.data)) {
                return showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            }
    
            if (groupNumList.data.length === 0) {
                return showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            }
            groupNumList = Array.isArray(groupNumList?.data) ? groupNumList.data : [];
            await this.setState({ groupNumList })
        }
        enableSpinner(false);

        await this.setState({ showSelectModal: true })
        $("#selectGroupNumModal").modal("show");
        $("#selectGroupNumModal").on("hidden.bs.modal", async () => {
            await this.setState({ showSelectModal: false });
        });
    }

    changeField = (field, value, type, maxLength, maxDecimals = null) => {
        let { model } = this.state;
        switch (type) {
            case "text":
                if (maxLength && value.length > maxLength) return;
                break;
            case "number":
                let auxValue = value.replace(/,/g, '');
                auxValue = (auxValue === '-' || auxValue === '.') ? '' : auxValue;
                if (isNaN(auxValue)) return;

                if (maxLength || maxDecimals !== null) {
                    const parts = auxValue.split('.');

                    if (maxLength && parts[0].length > maxLength) return;
                    if (maxDecimals !== null && parts[1]?.length > maxDecimals) return;

                    if (maxDecimals === 0) value = value.replace(/\./g, '');
                }
                break;
        }

        model[field] = value;
        this.setState({ model });
    }

    validateField = (field, type, decimals = 2, validNull = false) => {
        let { model } = this.state;
        let value = model[field];

        switch (type) {
            case "number":
                if (!value) value = '';
                let auxValue = value.replace(/,/g, '');
                auxValue = (auxValue === '-' || auxValue === '.') ? '' : auxValue;
                if (isNaN(auxValue)) value = Number(0).toFixed(decimals);
                else {
                    value = FORMAT_NUMBER(auxValue, decimals);
                    if (!auxValue && validNull) value = null;
                }
                break;
        }

        model[field] = value;
        this.setState({ model });
    }

    editMode = async (editMode) => {
        let auxModel = editMode ? JSON.parse(JSON.stringify(this.state.model)) : null;
        let model = editMode ? this.state.model : JSON.parse(JSON.stringify(this.state.auxModel));
        await this.setState({ editMode, model, auxModel });
    }

    validateModel = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { editMode, groupNum, model } = this.state;
        if (!model.PaymentTermsGroupName) return showAlert({ type: 'warning', message: 'Registra un código valido para la condición de pago' });

        enableSpinner(true);
        if (groupNum === null) {
            const response = await apiClient.createGroupNum({ model });
            if (!response?.status) { return showAlert({ type: 'warning', message: response?.message || 'Ocurrió un error inesperado' }); }
            showAlert({ type: 'success', message: response?.message });
            this.closeModal();
        } else if (editMode) {
            const response = await apiClient.updateGroupNum({ groupNum, model });
            if (!response?.status) { return showAlert({ type: 'warning', message: response?.message || 'Ocurrió un error inesperado' }); }
            showAlert({ type: 'success', message: response?.message });
            await this.setState({ editMode: false, auxModel: null });
        }
        enableSpinner(false);
    }

    render() {
        const { enableSearch } = this.props;
        const { editMode, groupNum, model, showSelectModal, groupNumList, priceList } = this.state;
        return (
            <div>
                <div className="modal fade bd-example-modal-md modal-open scroll" id="GroupNumbersModal">
                    <div className="modal-dialog modal-md modal-open">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title "> Condiciones de Pago {groupNum !== null ? "(Detalles)" : "(Nuevo)"}</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="d-flex justify-content-between">
                                    <div className="form-group">
                                        {(groupNum !== null && !editMode) &&
                                            <button type="button" className="btn btn-outline-dark border-0" onClick={() => this.editMode(true)}>
                                                <i className="fas fa-edit mr-2" /> Editar
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div className="input-group mb-3"> {/* PymntGroup */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtPymntGroup"> Código </label>
                                    </div>
                                    <input
                                        className="form-control"
                                        id="txtPymntGroup"
                                        disabled={groupNum !== null}
                                        value={model.PaymentTermsGroupName || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null) this.changeField("PaymentTermsGroupName", value, "text", 100); }} />
                                        
                                    {(!editMode && enableSearch) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            onClick={this.openSelectModal}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    )}
                                </div>

                                <div className="input-group mb-3"> {/* BslineDate */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="slcBslineDate"> Fecha de vencimiento basada en </label>
                                    </div>
                                    <select
                                        className="form-control"
                                        id="slcBslineDate"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.BaselineDate || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("BaselineDate", value); }} >
                                        <option value="P"> Fecha de contabilización </option>
                                        <option value="S"> Fecha del sistema </option>
                                        <option value="T"> Fecha del documento </option>
                                    </select>
                                </div>

                                <div className="input-group mb-3"> {/* PayDuMonth / ExtraMonth / ExtraDays */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="slcPayDuMonth"> Desde </label>
                                    </div>
                                    <select
                                        className="form-control"
                                        id="slcPayDuMonth"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.StartFrom || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("StartFrom", value); }} >
                                        <option value="E"> Final del mes </option>
                                        <option value="H"> Mitad del mes </option>
                                        <option value="Y"> Inicio del mes </option>
                                        <option value="N"> Ninguno </option>
                                    </select>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> + </span>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtExtraMonth"
                                        style={{ maxWidth: 45 }}
                                        disabled={groupNum !== null && !editMode}
                                        value={model.NumberOfAdditionalMonths || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("NumberOfAdditionalMonths", value, "number", 6, 0); }}
                                        onBlur={() => this.validateField("NumberOfAdditionalMonths", "number", 0)} />
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtExtraMonth"> Meses </label>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtExtraDays"
                                        style={{ maxWidth: 45 }}
                                        disabled={groupNum !== null && !editMode}
                                        value={model.NumberOfAdditionalDays || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("NumberOfAdditionalDays", value, "number", 6, 0); }}
                                        onBlur={() => this.validateField("NumberOfAdditionalDays", "number", 0)} />
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtExtraDays"> Días </label>
                                    </div>
                                </div>

                                <div className="input-group mb-3"> {/* TolDays */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtTolDays"> Días de tolerancia </label>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtTolDays"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.NumberOfToleranceDays || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("NumberOfToleranceDays", value, "number", 6, 0); }}
                                        onBlur={() => this.validateField("NumberOfToleranceDays", "number", 0, true)} />
                                </div>

                                <div className="input-group mb-3"> {/* OpenRcpt */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="slcOpenRcpt"> Abrir pago recibido </label>
                                    </div>
                                    <select
                                        className="form-control"
                                        id="slcOpenRcpt"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.OpenReceipt || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("OpenReceipt", value); }} >
                                        <option value="N"> No </option>
                                        <option value="1"> Cheques </option>
                                        <option value="2"> Transferencia </option>
                                        <option value="3"> Fondos en efectivo </option>
                                        <option value="4"> Crédito </option>
                                    </select>
                                </div>

                                <span className="font-weight-bold"> Campos de socio de negocio </span>
                                <hr />

                                <div className="input-group mb-3"> {/* VolumDscnt */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtVolumDscnt"> % Descuento total </label>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtVolumDscnt"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.GeneralDiscount || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("GeneralDiscount", value, "number", 12, 6); }}
                                        onBlur={() => this.validateField("GeneralDiscount", "number", 4)} />
                                </div>

                                <div className="input-group mb-3"> {/* LatePyChrg */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtLatePyChrg"> % De interés sobre créditos </label>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtLatePyChrg"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.InterestOnArrears || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("InterestOnArrears", value, "number", 12, 6); }}
                                        onBlur={() => this.validateField("InterestOnArrears", "number", 4)} />
                                </div>

                                <div className="input-group mb-3"> {/* ListNum */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="slcListNum"> Lista de precios </label>
                                    </div>
                                    <select
                                        className="form-control"
                                        id="slcListNum"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.PriceListNo || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("PriceListNo", value); }} >
                                        {priceList.map(({ListNum, ListName}) => <option key={ListNum} value={ListNum}> {ListName} </option>)}
                                        <option value="-1"> Último precio de compra </option>
                                        <option value="-1"> Último precio determinado </option>
                                    </select>
                                </div>

                                <div className="input-group mb-3"> {/* CredLimit */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtCredLimit"> Límite de crédito máximo </label>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtCredLimit"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.CreditLimit || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("CreditLimit", value, "number", 12, 6); }}
                                        onBlur={() => this.validateField("CreditLimit", "number", 2)} />
                                </div>

                                <div className="input-group mb-3"> {/* ObligLimit */}
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtObligLimit"> Límite comprometido </label>
                                    </div>
                                    <input
                                        className="form-control text-right"
                                        id="txtObligLimit"
                                        disabled={groupNum !== null && !editMode}
                                        value={model.LoadLimit || ""}
                                        onChange={({ target: { value } }) => { if (groupNum === null || editMode) this.changeField("LoadLimit", value, "number", 12, 6); }}
                                        onBlur={() => this.validateField("LoadLimit", "number", 2)} />
                                </div>
                            </div>

                            <div className="modal-footer">
                                {groupNum === null ? <button type="button" className="btn botonCorrect" onClick={this.validateModel}> Crear </button> :
                                    (!editMode ? "" : <><button type="button" className="btn botonCorrect" onClick={this.validateModel}> Guardar </button>
                                        <button type="button" className="btn botonCerrar text-white" onClick={() => this.editMode(false)}> Cancelar </button></>)}
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}> Cerrar </button>
                            </div>
                        </div>
                    </div>
                </div>
                {showSelectModal &&
                    <StandardSelectModal
                        id="selectGroupNumModal"
                        title="Lista de Condiciones de Pago"
                        headers={[{ title: "Condición de pago", value: true, filter: true, field: "PymntGroup", format: null, classes: "text-left" }]}
                        data={groupNumList}
                        selectAction={this.searchGroupNum} />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value }),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(GroupNumbersModal);
